module.exports = __webpack_public_path__ + "media/images/core-1f04fb34d30bc3121f7198b138638e4f.png";